/* global axios */
import ApiClient from './ApiClient';

class TalkviaInventorySuppliersAPI extends ApiClient {
  constructor() {
    super('talkvia_inventory_suppliers', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { talkvia_inventory_supplier: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      talkvia_inventory_supplier: data,
    });
  }
}

export default new TalkviaInventorySuppliersAPI();
